export enum Languages {
  CZ = 'cs',
  ENG = 'en',
  NL = 'nl',
}
